import fetch from "./httpFetch.js";
// const u = "/vir_gitee4146a331d5550/ceshiyingyong";
// 是否购买云服务
export function buyCloud() {
  return fetch.post(
    "/openplat-service-server/v/service/checkBuyCloudService",
    null,
    {
      errorHandler: true
    }
  );
}
// 我的基础信息
export function myInfo() {
  return fetch.post("/openplat-user-server/v/getUserInfoForHome");
}
// 我的余额
export function myBalance() {
  return fetch.post("/openplat-user-server/v/getUserBalanceInfo");
}
// 我的云资源额度
export function myCloud(data) {
  return fetch.post("/openplat-user-server/v/getUserCloudBalanceInfo", data);
}
// export function myCloud(type) {
//   let data = {
//     cloud_resource_type: type
//   };
//   return fetch.post("/openplat-user-server/v/getUserCloudBalanceInfo", data);
// }
// 我的api调用统计
export function myApi(data) {
  return fetch.post(
    "/openplat-user-server/v/getUserApiStatisticsForHome",
    data
  );
}
// 我的订单统计
export function myOrder() {
  return fetch.post("/openplat-user-server/v/getUserOrderStatisticsForHome");
}
// 设置额度可用额度预警
export function warningQuota(data) {
  return fetch.post("/openplat-user-server/v/setWarningQuota", data, {
    errorHandler: true
  });
}
// 我的服务统计
export function myService() {
  return fetch.post(
    "/openplat-service-server/v/service/getUserServiceStatisticsForHome"
  );
}
// 推荐服务列表
export function serviceList(data) {
  return fetch.post(
    "/openplat-service-server/v/service/queryRecommendService",
    data
  );
}
// export function serviceList(data) {
//   return fetch.post("/xyw/tuijianfuwuliebiao", data);
// }
// 获取平台公告列表
export function noticeList(data) {
  return fetch.post(
    "/openplat-service-server/v/system/queryBlogListForHome",
    data
  );
}
// 最近使用的服务
export function myUseService() {
  return fetch.post(
    "/openplat-user-server/v/getUserCloudResourceAccessRecords"
  );
}
// export function myUseService() {
//   return fetch.post("/xyw/zuijinshiyongdefuwu");
// }



// WEBPACK FOOTER //
// ./src/gtn/api/virtualBusiness.js